<template lang="pug">
  .wrapper-groups-details(:startOpen="true")
    .form-new
      Validate.name(v-model="name")
        PTextField(
          name="name"
          :label="'nome do ' + $ws('group')"
        )

      .items-slider
        RadioSlider(
          :items="categories.items",
          :current="categories.items.findIndex(i => i.id === categories.selected.id)",
          @selected="openItemsSelector"
        )

      .items-selector
        PMultiSelect(
          ref="itemSelector"
          labelItem="name"
          :title="categorieSelected.name"
          v-model="categoryData[categorieSelected.state]"
          :disabled="!categories.selected"
        )

      .button
        PButton(color="success" size="md" @click="save" :loading="loading") {{this.id ? 'editar': 'salvar'}}
        PButton(color="danger" size="md" @click="$emit('close')") fechar

</template>

<script>
import { mask } from 'vue-the-mask'
import RadioSlider from 'src/common/Tabs/RadioSlider'
import { useValidationsMixin } from 'src/common/validations'

export default {
  name: 'GroupsDetails',
  props: {
    id: {type: String, required: true}
  },
  data () {
    return {
      name: '',
      categoryData: {
        companies: { selected: null },
        userGroups: { selected: null }
      },
      categories: {
        selected: null,
        items: [
          { name: this.$wp('companyShortName'), id: 'company', common: 'companies/onlyActive', state: 'companies' },
          { name: 'grupos', id: 'userGroup', common: 'userGroups', state: 'userGroups' }
        ]
      },
      loading: false
    }
  },
  async created () {
    this.categoryData.companies = {
      selected: [],
      loaded: this.$store.state.common.companies.items
    }
    this.categoryData.userGroups = {
      selected: [],
      loaded: this.$store.state.common.userGroups.items.filter(item => item.id !== this.id)
    }
    this.categories.selected = this.categories.items[0]

    if (this.id) {
      try {
        const result = await this.$API.userGroup.get({ id: this.id })
        const group = result.body.success[0]
        this.name = group.name
        this.categoryData.companies.selected = group.companies
        this.categoryData.userGroups.selected = group.groups
      } catch (e) {
        const msg = e.data.error || 'Aconteceu um erro. Tente novamente.'
        this.$swal({
          type: 'error',
          title: 'Atenção',
          text: msg
        })
        this.$emit('close')
      }
    }
  },
  computed: {
    categorieSelected () {
      if (this.categories.selected) return this.categories.selected

      return {
        name: 'Selecionar',
        id: 'company',
        common: 'companies/onlyActive',
        useState: 'verifyTimesheet/companies'
      }
    },
    forcedPlaceholder () {
      const companies = this.categoryData.companies.selected || []
      const userGroups = this.categoryData.userGroups.selected || []

      if (companies.length || userGroups.length) {
        return null
      }

      if (this.categories.selected.id === 'company') {
        return 'selecionar ' + this.$wp('company')
      } else {
        return 'selecionar grupos'
      }
    }
  },
  methods: {
    openItemsSelector (item) {
      this.categories.selected = item
      this.$refs.itemSelector.open()
    },
    cleanSubmitData (action) {
      if (action === 'companies') {
        this.categoryData.userGroups.selected = []
      } else {
        this.categoryData.companies.selected = []
      }
    },
    async save () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      }

      // Deixa no categoryData apenas a última categoria (categorieSelected) atualizada
      this.cleanSubmitData(this.categorieSelected.state)
      const name = this.name
      const companies = this.categoryData.companies.selected || []
      const groups = this.categoryData.userGroups.selected || []

      if (!companies.length && !groups.length) {
        this.$swal({
          type: 'error',
          text: `Selecione pelo menos um ${this.$wp('company')}/${this.$ws('group')}`
        })
        return
      }

      this.loading = true
      const info = {}
      const data = { name, companies, groups }

      if (this.id) info.id = this.id
      try {
        await this.$API.userGroup.save(info, data)
        this.$swal({
          title: this.id ? `${this.$ws('group')} editado!` : `Novo ${this.$ws('group')}!`,
          type: 'success',
          text: `O ${this.$ws('group')} foi ${this.id ? 'editado' : 'adicionado'} com successo`
        })
        this.$emit('close')
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : 'Não foi possível salvar o ' + this.$ws('group')
        })
      }
      this.loading = false
    }
  },
  mixins: [useValidationsMixin({})],
  components: { RadioSlider },
  directives: { mask }
}
</script>

<style scoped lang="scss">
.wrapper-groups-details {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr;

  .form-new {
    grid-row: 2;
    display: grid;
    grid-template-columns: .7fr .7fr 1fr;
    grid-column-gap: 30px;
    align-items: center;
    grid-template-areas:
      "name category selector button";

    .name { grid-area: name }
    .button { grid-area: button; justify-self: end; }
    .items-selector { grid-area: selector }
    .items-slider {
      grid-area: category;
      align-self: center;
    }
  }
}
</style>
